import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface RecentTool {
  pluginId: string;
  lastVisitedAt: number;
}

interface RecentToolsState {
  recentTools: RecentTool[];
  trackVisit: (pluginId: string) => void;
  getRecent: (count?: number) => RecentTool[];
  clearRecent: () => void;
}

const MAX_RECENT = 10;

export const useRecentToolsStore = create<RecentToolsState>()(
  persist(
    (set, get) => ({
      recentTools: [],

      trackVisit: (pluginId: string) => {
        const now = Date.now();
        const existing = get().recentTools.filter((t) => t.pluginId !== pluginId);
        const updated = [{ pluginId, lastVisitedAt: now }, ...existing].slice(0, MAX_RECENT);
        set({ recentTools: updated });
      },

      getRecent: (count = 3) => {
        return get().recentTools.slice(0, count);
      },

      clearRecent: () => {
        set({ recentTools: [] });
      },
    }),
    {
      name: 'sopho-recent-tools',
      partialize: (state) => ({
        recentTools: state.recentTools,
      }),
    }
  )
);
